import { LOCALE_REGEX_PATTERN } from './constants';
/**
 * Parses valid locale
 *
 * @param {string} locale - Locale
 * @return {LocaleInfo} - Locale info
 *
 * @example
 * // returns { locale: 'en_gb', lang: 'en', country: 'gb', separator: '_' }
 * parseLocale('en_gb')
 */
const parseLocale = (locale) => { var _a; return (_a = locale.match(LOCALE_REGEX_PATTERN)) === null || _a === void 0 ? void 0 : _a.groups; };
export default parseLocale;
//# sourceMappingURL=parseLocale.js.map